import { MenuItem } from '@mui/material';
import SelectInput, { SelectChangeEvent } from '@mui/material/Select';
import clsx from 'clsx';
import React from 'react';
import { Option } from 'types/Generics';

import classes from './Select.module.scss';

interface SelectProps<T extends string | number | readonly string[]> {
    value: T;
    label?: string;
    error?: boolean;
    required?: boolean;
    className?: string;
    placeholder?: string;
    options: Array<Option<T>>;
    onChange?: (value: Option<T>) => void;
}

export const Select = <T extends string | number | readonly string[]>({
    value,
    options,
    className,
    placeholder,
    ...props
}: SelectProps<T>) => {
    const selectedOption = options.find(option => option.id === value);

    const changeHandler = (event: SelectChangeEvent<T>) => {
        const selectedOption = options.find(option => option.id === event.target.value);

        if (!selectedOption) {
            return;
        }

        props.onChange?.(selectedOption);
    };

    return (
        <SelectInput
            displayEmpty
            MenuProps={{ style: { maxHeight: 250 } }}
            {...props}
            value={selectedOption?.id || ''}
            renderValue={selectedOption => {
                if (!selectedOption) {
                    return <span className={classes.placeholder}>{placeholder || 'Select'}</span>;
                }

                return options.find(option => option.id === selectedOption)?.name;
            }}
            className={clsx(classes.root, className)}
            onChange={changeHandler}
        >
            {options.map((option, index) => (
                <MenuItem key={index} value={option.id} className={classes.option}>
                    {option.name}
                </MenuItem>
            ))}
        </SelectInput>
    );
};
